import React from "react";
const Columns = (
  addUpd,
  destroy,
  active,
  items,
  setItems,
  duplicateBranch,
  authUser
) => {
  const duplicate = (row) => {
    duplicateBranch(row).then((response) => {
      if (response.status) {
        const newItem = response.branch;
        let array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
        setItems(array);
      }
    });
  };

  let columns = [
    {
		id: "numero",
		name: "Número",
		selector: (row) => row.numero,
		sortable: true,
	},
	{
      id: "name",
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      id: "alias",
      name: "Nombre Corto",
      width: "150px",
      selector: (row) => (row.alias ? row.alias : "N/A"),
      sortable: true,
    },
    {
      id: "time_before",
      name: "Ajuste Tiempo Antes",
      width: "160px",
      selector: (row) => row.time_before,
      sortable: true,
    },
    {
      id: "time_after",
      name: "Ajuste Tiempo Despues",
      width: "160px",
      selector: (row) => row.time_after,
      sortable: true,
    },
    {
      id: "actions",
      name: "Acciones",
      width: "15%",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="pe-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar ramal"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>
          <div className="pe-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar ramal"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];

  if(authUser.profile_id==2) {
	columns = [
		{
			id: "ruta",
			name: "Ruta",
			selector: (row) => row.route.name,
			sortable: true,
			wrap: true,
		},
		...columns
	]
  }
  return columns;
};

export default Columns;

//vaneton beicli
